import 'css-chunk:src/app/components/FilterMenuPopover/FilterMenuPopover.scss';export default {
  "FilterMenuPopover": "_FilterMenuPopover_xmdy3_1",
  "select": "_select_xmdy3_4",
  "searchInput": "_searchInput_xmdy3_18",
  "list": "_list_xmdy3_22",
  "item": "_item_xmdy3_44",
  "source": "_source_xmdy3_48",
  "highlight": "_highlight_xmdy3_52",
  "selectItem": "_selectItem_xmdy3_56"
};